import React from "react";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

/**
 * Reusable offer card.
 * variant: "default" | "featured" | "compact"
 */
export default function OfferCard({
  image,
  imageSrcSet,
  imageAlt,
  badge,
  title,
  price,
  priceNote,
  wasPrice,
  description,
  includes = [],
  ctaText = "Book This Service",
  ctaLink = "/#schedule",
  finePrint,
  variant = "default",
  testid,
}) {
  const isCompact = variant === "compact";
  const isFeatured = variant === "featured";

  return (
    <article
      className={`offer-card offer-card-${variant}`}
      data-testid={testid || `offer-card-${(title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      {image && (
        <div className="offer-card-media">
          <img
            src={image}
            srcSet={imageSrcSet}
            sizes="(min-width: 900px) 600px, 100vw"
            alt={imageAlt || ""}
            loading="lazy"
            decoding="async"
            width="800"
            height="450"
          />
          {badge && <span className="offer-card-badge" aria-label={badge}>{badge}</span>}
        </div>
      )}

      <div className="offer-card-body">
        <h3 className="offer-card-title">{title}</h3>

        <div className="offer-card-price-row">
          {priceNote && <span className="offer-card-price-note">{priceNote}</span>}
          <div className="offer-card-price-line">
            {wasPrice && <span className="offer-card-was">{wasPrice}</span>}
            <span className="offer-card-price">{price}</span>
          </div>
        </div>

        {description && <p className="offer-card-desc">{description}</p>}

        {!isCompact && includes && includes.length > 0 && (
          <ul className="offer-card-includes">
            {includes.slice(0, 4).map((item) => (
              <li key={item}>
                <span aria-hidden="true" className="offer-card-check">✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        )}

        <div className="offer-card-cta-row">
          <Link
            to={ctaLink}
            className="btn btn-primary offer-card-cta"
            data-testid={`offer-cta-${(title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            onClick={() => trackEvent("InitiateCheckout", { content_type: "special", content_name: title })}
          >
            {ctaText} →
          </Link>
        </div>

        {finePrint && !isCompact && <p className="offer-card-fineprint">{finePrint}</p>}
      </div>

      {isFeatured && badge && <span className="offer-card-featured-badge">{badge}</span>}
    </article>
  );
}
